<template>
    <div ref="mo_root" class="mo_root" :style="pageRootStyle">
        <!-- tab 顶部导航 -->
        <div class="tab">
            <div class="logo" @click="onClickHome">
                <img src="../../static/mo/logo.png" alt="">
            </div>
            <div class="top_btn_wrap">
                <div v-if="showGuide || showFun" class="top_btn_lang" ref="langBtn">
                    <div class="lang_trigger" @click="toggleLangPicker">
                        <img src="../../static/pc/top_btn_lang.png" alt="">
                    </div>
                    <div v-if="showLangPicker" class="lang_overlay" @click.self="showLangPicker = false"></div>
                    <div v-if="showLangPicker" class="lang_dropdown_wrap">
                        <div class="lang_dropdown" ref="langDropdown">
                            <div
                                v-for="opt in LANG_OPTIONS"
                                :key="opt.key"
                                class="lang_dropdown_item"
                                :class="{ active: lang === opt.key }"
                                @click="switchLang(opt.key)"
                            >{{ opt.label }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="showGuide" class="icon_filter" @click="openFilter">
                    <img src="../../static/guide/mo/icon_filter.png" alt="">
                </div>
                <!-- <div v-if="!showGuide && wikiEnabled" class="icon_filter" @click="onClickCard">
                    <img src="../../static/pc/card.png" alt="">
                </div> -->
                <div class="top_btn_nav" ref="navBtn">
                    <div class="nav_trigger" @click="openNav">
                        <img src="../../static/icon_nav.png" alt="">
                    </div>
                    <div v-if="showNav" class="nav_overlay" @click.self="showNav = false"></div>
                    <div v-if="showNav" class="nav_dropdown_wrap">
                        <div class="nav_dropdown">
                            <div class="nav_item" :class="{ active: isHomeActive }" @click="onNavHome">Home</div>
                            <!-- <div class="nav_item" :class="{ active: isGalleryActive }" @click="onNavGallery">Gallery</div> -->
                            <div class="nav_item" :class="{ active: showFun }" @click="onNavFun">HABBY FUN</div>
                            <div class="nav_item" v-if="wikiEnabled" :class="{ active: showGuide }" @click="onNavWiki">Wiki</div>
                            <div class="nav_item nav_item_discord" @click="onNavDiscord">
                                <img class="nav_item_icon" src="../../static/Vector.png" alt="">
                                <span>Discord</span>
                            </div>
                            <!-- <div class="nav_item" @click="onNavRedeem">Redeem Guild</div> -->
                        </div>
                    </div>
                </div>
                <!-- <div class="top_btn_steam">
                    <a href="https://discord.com/invite/FzMHcNpaKH" target="_blank"><img src="../../static/mo/top_btn_3.png" alt=""></img></a>
                </div> -->
            </div>
            <transition name="slide">
                <div v-if="isShowSelect" class="app_wrap">
                    <div class="img" @click="isPublic = true"><img src="../../static/mo/w.png" alt=""></div>
                    <div class="img"><a :href="RE.d" target="_target"><img src="../../static/mo/d.png" alt=""></a></div>
                    <div class="img"><a :href="RE.h" target="_target"><img src="../../static/mo/h.png" alt=""></a></div>
                </div>
            </transition>
        </div>

        <!-- 图鉴内容 -->
        <GuideMobile v-if="showGuide" :parent-lang="lang" ref="guideMobile" />

        <!-- HABBY FUN 页面 -->
        <FunMobile v-if="showFun" :parent-lang="lang" />

        <!-- 主页内容 -->
        <template v-if="!showGuide && !showFun">
            <!-- banner 首图 -->
            <div class="banner_wrap">
                <div class="title"> <img src="../../static/mo/title.png" alt=""> </div>

                <div class="banner_btn_wrap">
                    <div @click="onClickSteam" class="btn_Steam">
                        <img src="../../static/btn_Steam.png" alt="">
                    </div>
                    <!-- 临时 Discard -->
                    <!-- <div @click="onClickComponent" class="banner_btn">
                        <img src="../../static/Component.png" alt="">
                    </div> -->
                </div>
            </div>

            <!-- 轮播 -->
            <div class="reference">
                <!-- 分割线 -->
                <div class="segmentation">
                    <img src="../../static/mo/segmentation.png" alt="">
                </div>

                <img class="swiper_bg" src="../../static/mo/swiper_bg.png" alt="">

                <div class="swiper_wrap" ref="swiperContainer">
                    <img class="swiper_title" src="../../static/mo/swiper_title.png" alt="">
                    <div id="carousel" class="carousel">
                        <swiper v-if="swiperInitialized" :options="swiperOptionMo" v-once>
                            <swiper-slide v-for="(image, index) in imagesMo" :key="index">
                                <img class="slide_img" :src="image" :alt="'Image ' + (index + 1)">
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination">
                            </div>
                        </swiper>
                        <div class="swiper_slide_bg">
                            <img src="../../static/mo/swiper_slide_bg.png" alt="">
                        </div>
                    </div>
                </div>

                <img class="swiper_next" src="../../static/mo/swiper_next.png" alt="">
            </div>
        </template>

        <Footer></Footer>

        <!-- 公众号 -->
        <div class="showPageWrap" v-if="isPublic">
            <div class="tipWrap">
                <div class="closeWrap">
                    <img class="isTip" src="../../static/pc/public.png" alt="">
                    <div class="close" @click="isPublic = false">
                        <img style="opacity: 0;" src="../../static/mo/close.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 分享  -->
        <div class="showPageWrap" v-if="isTip">
            <div class="tipWrap">
                <div class="closeWrap">
                    <img class="isTip" src="../../static/mo/isTip.png" alt="">
                    <div class="close" style="opacity: 0;" @click="isTip = false">
                        <img src="../../static/mo/close.png" alt="" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 视频弹窗 -->
        <VideoModal
            v-if="isShowVideo"
            :videoSrc="currentVideoSrc"
            @handleClose="handleCloseVideo"
        />

        <!-- 敬请期待提示 -->
        <transition name="toast-fade">
            <div v-if="showToast" class="coming-soon-toast">敬请期待～</div>
        </transition>
    </div>
</template>

<script>
import pcLogic from './index.js'
import VideoModal from '@/components/VideoModal.vue'
import GuideMobile from './guide/GuideMobile.vue'
import FunMobile from './fun/FunMobile.vue'
import { TGA } from '@/utils/tga'

export default {
    props: ['language'],
    components: {
        VideoModal,
        GuideMobile,
        FunMobile
    },
    mixins: [pcLogic],
    data() {
        return {
            showNav: false,
            scrollTop: 0
        };
    },
    mounted() {
        const root = this.$refs.mo_root;
        if (root) {
            root.addEventListener('scroll', this.onMoRootScroll, { passive: true });
        }
    },
    beforeDestroy() {
        const root = this.$refs.mo_root;
        if (root) {
            root.removeEventListener('scroll', this.onMoRootScroll);
        }
    },
    computed: {
        pageRootStyle() {
            if (this.showGuide) return { backgroundColor: '#f5e6d3' };
            if (this.showFun) return { backgroundColor: '#000' };
            return {};
        },
        isGalleryActive() {
            void this.scrollTop;
            if (this.showGuide || this.showFun) return false;
            const root = this.$refs.mo_root;
            const swiper = this.$refs.swiperContainer;
            if (!root || !swiper) return false;
            const rootRect = root.getBoundingClientRect();
            const targetRect = swiper.getBoundingClientRect();
            return (targetRect.top - rootRect.top) <= rootRect.height / 2;
        },
        isHomeActive() {
            return !this.showGuide && !this.showFun && !this.isGalleryActive;
        }
    },
    methods: {
        onMoRootScroll() {
            this.scrollTop = this.$refs.mo_root ? this.$refs.mo_root.scrollTop : 0;
        },
        openNav() {
            this.showNav = !this.showNav;
        },
        onNavHome() {
            TGA.trackClick('Home');
            this.showNav = false;
            this.onClickHome();
        },
        onNavGallery() {
            TGA.trackClick('Gallery');
            this.showNav = false;
            this.scrollToSwiper();
        },
        onNavFun() {
            this.showNav = false;
            this.onClickFun();
        },
        onNavWiki() {
            TGA.trackClick('Wiki');
            this.showNav = false;
            this.showFun = false;
            this.showGuide = true;
            this.scrollToTop();
        },
        onNavDiscord() {
            this.showNav = false;
            this.onClickDiscord();
        },
        onNavRedeem() {
            this.showNav = false;
            this.showToast = true;
            setTimeout(() => {
                this.showToast = false;
            }, 2000);
        },
        toggleLangPicker() {
            this.showLangPicker = !this.showLangPicker;
            if (this.showLangPicker) {
                this.$nextTick(() => {
                    const dropdown = this.$refs.langDropdown;
                    if (dropdown) {
                        const active = dropdown.querySelector('.active');
                        if (active) {
                            active.scrollIntoView({ block: 'center' });
                        }
                    }
                });
            }
        },
        openFilter() {
            if (this.$refs.guideMobile) {
                this.$refs.guideMobile.showFilter = true;
            }
        },
        onClickHome() {
            this.showGuide = false;
            this.showFun = false;
            this.scrollToTop();
        }
    }
}
</script>

<style scoped lang="less">
@import "./mobile.less";

.coming-soon-toast {
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    font-size: 18px;
    padding: 12px 30px;
    border-radius: 10px;
    z-index: 9999;
    pointer-events: none;
    letter-spacing: 2px;
}

.toast-fade-enter-active {
    transition: opacity 0.5s ease;
}
.toast-fade-leave-active {
    transition: opacity 1s ease;
}
.toast-fade-enter,
.toast-fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/mobile.vue